module.exports = __webpack_public_path__ + "static/1366-f98a8d438e9200354c5a3788d141a6a8.svg";